/**
 * @(#)2020/3/30.
 * Range，用于输入数字区间
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React, { Component } from "react";
import { Row, Col } from "antd";
import Basics from "../Basics";
import RangeNumber from "./Range";
import { get, cloneDeep } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";
import { l } from "../../../config/language";

/*
 * -----------------------公共部分参数--------------------------------------------------
 * @param onChange {object} 输入框发生变化的回调，返回对象为一个数组
 * @param section {array} 区间，数组第一项/第二项为数组，数组可包含一个数字或两个数字，为一个数字时，该输入框的最小值和
 *        最大值都为该数字，为两个数字时，数组的第一个值和第二个值为第一个/第二个输入框的最小值和最大值
 * @param firstParams {object} 第一个输入框的参数，继承Number属性
 * @param secondParams {object} 第一个输入框的参数，继承Number属性
 * */
//默认props
let defaul = () => {
  return {
    rules: {
      max: "",
      required: false,
    },
    getFieldDecoratorParam: {},
    children: "",
  };
};
@Connection(defaul)
class Range extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  rules(tmpProps) {
    //验证是否为空
    if (tmpProps.rules.required === true) {
      tmpProps.rules.validator = {
        validator: async (r, v, c) => {
          let f = v[0];
          let s = v[1];
          if (f != 0 && s != 0 && !f && !s) {
            c(l("defaultRules.rt", this, { label: tmpProps.label }));
          }
        },
      };
    }
    //验证完整性
    tmpProps.rules.complete = {
      validator: async (r, v, c) => {
        let f = get(v, "[0]");
        let s = get(v, "[1]");
        if (v && (f || s)) {
          if (
            f === "" ||
            f === undefined ||
            f === null ||
            s === "" ||
            s === undefined ||
            s === null
          ) {
            c(l("Range.pc", this, { label: tmpProps.label }));
          }
        }
      },
    };
    return tmpProps;
  }

  productionHtml() {
    let tmpProps = { ...this.props };
    tmpProps = this.rules(tmpProps);
    tmpProps.getFieldDecoratorParam.valuePropName = "setValue";
    tmpProps.children = <RangeNumber {...tmpProps} />;
    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    //合并默认参数和外部参数
    return <div className="yx_yxInput_range">{this.productionHtml()}</div>;
  }
}
export default Range;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Range/yxRange.js